import { useEffect } from 'react';
import { Linkedin, Github, Instagram, Download } from 'lucide-react';
import classes from './ProfileData.module.css';
import Typed from 'typed.js';
const ProfileData = () => {
  useEffect(() => {
    const typed = new Typed('#element', {
      strings: [
        'ReactJS developer!',
        'nodeJS Developer!',
        'MongoDb developer!',
        'Python developer!',
        'Java Developer!',
        'Android Developer!',
      ],
      typeSpeed: 100,
      loop: true,
    });
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div className={classes.leftSection}>
      <div>
        {' '}
        Hi, i'm <br />
        <span className={classes.colorName}>Rahul Nair</span>
      </div>
      <div>I am a passionate </div>
      <span id='element'></span>
      <div className={classes.social}>
        <div className={classes.socialContainer}>
          <div className={classes.socialIcons}>
            <a
              href='https://www.linkedin.com/in/rahul-nair-66a189228'
              target='_blank'
              rel='noreferrer'
            >
              <Linkedin size={30} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
          <div className={classes.socialIcons}>
            <a
              href='https://www.github.com/rahul-tsx'
              target='_blank'
              rel='noreferrer'
            >
              {' '}
              <Github size={30} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
          <div className={classes.socialIcons}>
            <a
              href='https://instagram.com/rahul_nair29?igshid=NGExMmI2YTkyZg=='
              target='_blank'
              rel='noreferrer'
            >
              <Instagram size={30} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className={classes.cvIcon}>
          <a
            href='https://drive.google.com/file/d/1M8v-dLq3-kVqxN0kXbYmRhdAZx9IVcPd/view?usp=drive_link'
            download='rahulnaircv.pdf'
            target='_blank'
            rel='noreferrer'
          >
            <button>
              Download CV{' '}
              <span className={classes.bottonIcon}>
                <Download size={30} color='#f5a623' strokeWidth={1.75} />
              </span>
            </button>
          </a>
        </div>
      </div>
      <div className={classes.socials}>
        <div className={classes.socialContainer}>
          <div className={classes.socialIcons}>
            <a
              href='https://www.linkedin.com/in/rahul-nair-66a189228'
              target='_blank'
              rel='noreferrer'
            >
              <Linkedin size={25} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
          <div className={classes.socialIcons}>
            <a
              href='https://www.github.com/rahul-tsx'
              target='_blank'
              rel='noreferrer'
            >
              <Github size={25} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
          <div className={classes.socialIcons}>
            <a
              href='https://instagram.com/rahul_nair29?igshid=NGExMmI2YTkyZg=='
              target='_blank'
              rel='noreferrer'
            >
              <Instagram size={25} color='#f5a623' strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className={classes.cvIcon}>
          <a
            href='https://drive.google.com/file/d/1M8v-dLq3-kVqxN0kXbYmRhdAZx9IVcPd/view?usp=drive_link'
            download='rahulnaircv.pdf'
            target='_blank'
            rel='noreferrer'
          >
            <button>
              Download CV{' '}
              <span className={classes.bottonIcon}>
                <Download size={15} color='#f5a623' strokeWidth={1.75} />
              </span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
export default ProfileData;
